<template>
  <section id="contact" class="bg-white dark:bg-dark-surface transition-colors duration-300">
    <div class="relative overflow-hidden bg-gradient-to-r from-indigo-600 to-indigo-900 py-20 transition-colors duration-300">
      <div class="absolute inset-0 cta-pattern pointer-events-none"></div>
      <div class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 class="text-3xl font-extrabold text-white sm:text-4xl mb-6 transition-colors duration-300">{{ t('cta.title') }}</h2>
        <p class="text-xl text-gray-300 max-w-2xl mx-auto mb-10 transition-colors duration-300">{{ t('cta.subtitle') }}</p>
        <a href="#contact-info" class="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-base font-bold rounded-full text-indigo-950 bg-accent hover:bg-accent-dark transition-colors duration-300 shadow-lg hover:shadow-xl">
          {{ t('cta.button') }}
        </a>
      </div>
    </div>
    
    <div id="contact-info" class="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-5xl mx-auto text-center">
        <div class="bg-gray-50 dark:bg-dark-surface/50 p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 animate-on-scroll animate-in">
          <div class="w-16 h-16 bg-indigo-100 dark:bg-indigo-900/40 rounded-full flex items-center justify-center mx-auto mb-6 transition-colors duration-300">
            <Mail class="w-6 h-6 text-primary dark:text-accent transition-colors duration-300" />
          </div>
          <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2 transition-colors duration-300">{{ t('contact.emailUs') }}</h3>
          <a :href="`mailto:${t('contact.email')}`" class="text-gray-600 dark:text-gray-400 hover:text-accent transition-colors duration-300">{{ t('contact.email') }}</a>
        </div>
        
        <div class="bg-gray-50 dark:bg-dark-surface/50 p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 animate-on-scroll animate-in" style="animation-delay: 100ms;">
          <div class="w-16 h-16 bg-indigo-100 dark:bg-indigo-900/40 rounded-full flex items-center justify-center mx-auto mb-6 transition-colors duration-300">
            <MapPin class="w-6 h-6 text-primary dark:text-accent transition-colors duration-300" />
          </div>
          <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2 transition-colors duration-300">{{ t('contact.visitUs') }}</h3>
          <p class="text-gray-600 dark:text-gray-400 transition-colors duration-300">{{ t('contact.address') }}</p>
        </div>
        
        <div v-if="t('contact.phone')" class="bg-gray-50 dark:bg-dark-surface/50 p-8 rounded-2xl shadow-md hover:shadow-xl md:col-span-2 lg:col-span-1 transition-all duration-300 animate-on-scroll animate-in" style="animation-delay: 200ms;">
          <div class="w-16 h-16 bg-indigo-100 dark:bg-indigo-900/40 rounded-full flex items-center justify-center mx-auto mb-6 transition-colors duration-300">
            <Phone class="w-6 h-6 text-primary dark:text-accent transition-colors duration-300" />
          </div>
          <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2 transition-colors duration-300">{{ t('contact.callUs') }}</h3>
          <p class="text-gray-600 dark:text-gray-400 transition-colors duration-300">{{ t('contact.phone') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { Mail, MapPin, Phone } from 'lucide-vue-next'
import { useAnimateOnScroll } from '@/composables/useAnimateOnScroll'

const { t } = useI18n({ useScope: 'global' })
const { observeElements } = useAnimateOnScroll()

onMounted(() => {
  observeElements('.animate-on-scroll')
})
</script>

<style scoped>
.cta-pattern {
  background-image: radial-gradient(circle, rgba(255,255,255,0.15) 1px, transparent 1px);
  background-size: 24px 24px;
}
</style>
